












import { defineComponent, reactive, watch } from '@vue/composition-api';
import _ from 'lodash';

import storage, { DownloadSetting } from '@/renderer/scripts/utils/storage';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';

export default defineComponent({
  name: 'DownloadPath',
  setup() {
    const downloadSetting = reactive<DownloadSetting>({
      downloadPath: '',
      noAskDownloadPath: false,
    });
    const selectDownloadPath = async () => {
      const { filePaths } = await ipc.invoke(IpcEvents.INVOKE_OPERATE_MAIN_LISTENER, { event: 'selectFolders' });
      if (!filePaths || !filePaths.length) return;
      [downloadSetting.downloadPath] = filePaths;
    };
    // set data
    const onTransmissionChange = _.debounce(
      () => {
        storage.set(storage.StoreKey.DOWNLOAD_SETTING, downloadSetting);
      },
      2000,
      { leading: true },
    );

    watch(downloadSetting, () => {
      onTransmissionChange();
    });

    // read data
    const storageDownloadSetting: DownloadSetting = storage.get<DownloadSetting>(storage.StoreKey.DOWNLOAD_SETTING);

    // recover data 恢复数据到组件实例
    if (storageDownloadSetting) {
      downloadSetting.downloadPath = storageDownloadSetting.downloadPath;
      downloadSetting.noAskDownloadPath = storageDownloadSetting.noAskDownloadPath;
    }
    return {
      downloadSetting,
      selectDownloadPath,
    };
  },
});
